export default __webpack_public_path__ + "static/media/icons-arrow-next.20d5bff3.svg";